/**
 * Animation timing constants for Focus Mode
 */
export const FOCUS_MODE_ANIMATION = {
  DURATION: 400, // milliseconds
  CLOSE_BUFFER: 50, // buffer time before actual close
  SIDEBAR_FADE_DURATION: 300,
  EASING: "cubic-bezier(0.4, 0, 0.2, 1)" as const,
} as const;

/**
 * Calculated timing values
 */
export const FOCUS_MODE_TIMING = {
  CLOSE_DELAY:
    FOCUS_MODE_ANIMATION.DURATION + FOCUS_MODE_ANIMATION.CLOSE_BUFFER,
} as const;
